var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailDeprecatedIcon = function SvgEmailDeprecatedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9488_17691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6252 16.3008C14.2393 16.5692 13.8218 16.8042 13.3702 16.9908C12.5327 17.3383 11.6652 17.5 10.811 17.5C7.36852 17.5 4.53602 14.8992 4.16602 11.555",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7847 10.8117V11.9267C13.7847 12.9534 14.6164 13.7842 15.6422 13.7842C16.6689 13.7842 17.4997 12.9525 17.4997 11.9267V10.8117C17.4997 7.36919 14.8989 4.53669 11.5547 4.16669",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62435 9.58335C3.43852 9.58335 1.66602 7.81085 1.66602 5.62502C1.66602 3.43919 3.43852 1.66669 5.62435 1.66669C7.81018 1.66669 9.58268 3.43919 9.58268 5.62502C9.58268 7.81085 7.81018 9.58335 5.62435 9.58335Z",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50781 4.50836L6.74115 6.7417",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50781 6.7417L6.74115 4.50836",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94336 11.555C8.27503 12.835 9.42753 13.7842 10.8109 13.7842C12.4525 13.7842 13.7834 12.4533 13.7834 10.8117C13.7834 9.42832 12.8334 8.27582 11.5542 7.94415",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9488_17691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgEmailDeprecatedIcon as ReactComponent };
export default __webpack_public_path__ + "email-deprecated-icon.svg";